export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 grid gap-6 md:grid-cols-3 text-sm text-slate-700 dark:text-slate-300">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/hook2.svg" alt="" className="w-6 h-6"/>
            <span className="font-semibold">The Daybook</span>
          </div>
          <p className="opacity-80">A modern operations daybook to keep projects on track.</p>
          <img src="/img/cranelogix-transparent-bg.png" alt="Cranelogix" className="w-64 mt-3 mb-3"/>
          {/* Address details */}
          <address className="not-italic opacity-80">
            Office 1<br/>
            St Ives Enterprise Centre<br/>
            Caxton Road<br/>
            St Ives<br/>
            Cambridgeshire<br/>
            PE27 3NP
          </address>
          {/* Made with love note */}
          <p className="opacity-80 pt-10">Made with 💙 in the UK.</p>
        </div>
        <div>
          <h3 className="font-semibold mb-3">More Information</h3>
          <ul className="space-y-2">
            <li><a className="hover:underline" href="/about">About</a></li>
            {/* <li><a className="hover:underline" href="/pricing">Pricing</a></li> */}
            <li><a className="hover:underline" href="/contact">Contact</a></li>
          </ul>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Our Products</h3>
          <ul className="space-y-2">
            <li><a className="hover:underline" href="/contact">The Daybook</a></li>
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-slate-400 pb-8">© <span id="y">{new Date().getFullYear()}</span> CraneLogix Ltd / The Daybook. All rights reserved.</div>
    </footer>
  )
}
